import React, { use, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toggleCheckedItemT, setRowsT, setPageT, setMaxPagesT, setSortingT, setCheckedItemT, toggleAddModalT, toggleEditModalT } from '../../../store/opinionsTTabSlice.js';
import {
  getHeaders,
  headerWidths,
  tabsConfig,
  buttonsConfig,
  leftSideConfig,
  rightSideConfig,
  empty,
  sortButtonsConfig,
} from './opinionsTableConfigAboutTrainings.js';
import Table from '../../../components/list2/table';
import Pagination from '../../../components/components/pagination/pagination.jsx';
import { fetchOpinionsT } from './opinionsTTableService';


import { ReactComponent as StarFilled } from '../../../components/icons/star-filled.svg';
import { ReactComponent as StarEmpty } from '../../../components/icons/star-empty.svg';

function OpinionsT() {

  const dispatch = useDispatch();

  const activeTab = useSelector((state) => state.opinions.activeTab);

  const totalPagesT = useSelector((state) => state.opinionsT.maxPages);
  const currentPageT = useSelector((state) => state.opinionsT.currentPage);
  const sortByT = useSelector((state) => state.opinionsT.sortBy);
  const sortDirectionT = useSelector((state) => state.opinionsT.sortDirection);
  const checkedItemsT = useSelector((state) => state.opinionsT.checkedItems);
  const addModalOpenT = useSelector((state) => state.opinionsT.addModalOpen);
  const editModalOpenT = useSelector((state) => state.opinionsT.editModalOpen);
  const keywordT = useSelector((state) => state.opinionsT.keyword);
  const searchValueT = useSelector((state) => state.opinionsT.searchValue);
  const sortSortListEndpointT = useSelector((state) => state.opinionsT.sortSortListEndpoint);
  const rowsT = useSelector((state) => state.opinionsT.rows);
  const needRefreshT = useSelector((state) => state.opinionsT.needRefresh);

  const sortArrowColorActive = '#060606';
  const sortArrowColorInactive = '#06060650';

    // Funkcja otwierająca modal (Redux Action)
    const handleToggleAddModal = () => {
      dispatch(toggleAddModalT());
    };
    const handleToggleEditModal = () => {
      dispatch(toggleEditModalT());
    };

  useEffect(() => {
    fetchOpinionsT(sortByT, sortDirectionT, keywordT, currentPageT, dispatch, checkedItemsT);

  }, [currentPageT, sortByT, sortDirectionT, checkedItemsT, needRefreshT, keywordT]);



  const renderedRows = rowsT.map((row) => [
    <input
        type="checkbox"
        checked={row.checked}
        onChange={() => dispatch(toggleCheckedItemT(row.id))}
    />,
    row.id,
    row.addedOn,
    row.trainingName,
    row.userName,
    <div style={{ display: 'flex', justifyContent: 'center'
    }}>
      <img className='row-image' src={row.sportName} alt="FOTO" />
    </div>,
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
      {[...Array(row.scoreLevel)].map((_, index) => (
          <StarFilled />
      ))}
      {[...Array(5 - row.scoreLevel)].map((_, index) => (
          <StarEmpty />
      ))}
    </div>,
    row.senderName,
  ]);


  let headers = getHeaders(
    sortByT,
    sortDirectionT,
    dispatch,
    setSortingT,
    sortArrowColorActive,
    sortArrowColorInactive,
    rowsT,
    checkedItemsT);

    const paginationProps = {
      reduxSelector: (state) => state.opinionsT.currentPage,
      reduxAction: setPageT,
      totalPages: totalPagesT,
      maxVisibleButtons: 5,
    };

    const rightSideConfig2 = [
      {
        component: Pagination, // Komponent do wyrenderowania
        props: paginationProps, // Właściwości przekazywane do komponentu
      },
    ];

  return (
    <div className="table-container">
      <Table
        headers={headers}
        rowsClass='row-sports'
        cellClass='cell-sports'
        rows={renderedRows}
        columnWidths={headerWidths}
        idViewing={true}
        idArrayId={1}
        cellClass2='cell-center'
        cellClass2ConditionList={[1, 4, 5, 6]} />
    </div>
  );
}

export default OpinionsT;